import isEmpty from 'lodash/isEmpty';

import { keepPreviousData, useQuery as useTanstackQuery } from '@tanstack/react-query';

import { DEFAULT_QUERY_NAMESPACE, urlToQueryKey } from './utils';


function useBaseQuery(url, client, params) {
  const {
    namespace = DEFAULT_QUERY_NAMESPACE, queryParams = {}, keepPrevious = false, ...restParams
  } = params || {};

  const queryFn = ({ signal }) => client.request({ url, payload: queryParams, options: { signal } });
  const queryKey = isEmpty(queryParams)
    ? [namespace, ...urlToQueryKey(url)]
    : [namespace, ...urlToQueryKey(url), queryParams];

  // Opt-in keep-previous-data: when a query's key changes (pager, filters,
  // search…) the prior page's data backs the new fetch instead of dropping to
  // `undefined`, so the table can show a refresh overlay over stale rows.
  const placeholderData = keepPrevious ? keepPreviousData : restParams.placeholderData;

  const query = useTanstackQuery({ queryKey, queryFn, retry: 1, ...restParams, placeholderData });

  return { ...query, queryKey };
}

export default useBaseQuery;
